/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { StartAdminMarketCreationResponse, StartAdminMarketCreationVars } from '../openapi-types.gen.js';

export type { StartAdminMarketCreationResponse, StartAdminMarketCreationVars } from '../openapi-types.gen.js';

export const useStartAdminMarketCreation = createMutationHook<StartAdminMarketCreationVars, StartAdminMarketCreationResponse, unknown>({
  specName: 'useStartAdminMarketCreation',
  path: '/v1/admin/market-creations',
  method: 'POST',
  resolveUrl: (vars: StartAdminMarketCreationVars) => `/v1/admin/market-creations`,
  buildBody: (vars: StartAdminMarketCreationVars) => ({ proof: vars.proof, creatorProof: vars.creatorProof, parameters: vars.parameters }),
  parseResponse: (raw: unknown): StartAdminMarketCreationResponse => raw as StartAdminMarketCreationResponse,
  
  
  
});
